import firebase from 'firebase'
import firestore from 'firebase/firestore'
// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCUK_LUvrldqXH8CdUmt1T5a9rie6StMp4",
    authDomain: "meow-smoothie.firebaseapp.com",
    databaseURL: "https://meow-smoothie.firebaseio.com",
    projectId: "meow-smoothie",
    storageBucket: "",
    messagingSenderId: "1030318218229",
    appId: "1:1030318218229:web:41998acabdb62ee0"
  };

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);


export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js